import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'
import {
  MetadataIconStyles,
  StyledIconContainer,
  OneLineEllipsisStyles,
  IconStyles
} from '../index.css'

const StyledMetadataIcon = styled.div`
  ${MetadataIconStyles}
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
`

const StyledMessageContainer = styled.div`
  ${OneLineEllipsisStyles}
`

const StyledAnnotationNote = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.annotationNote
})`
  ${IconStyles}
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  padding-top: 2px;
  font-size: ${sys.typescale[12].size};
`

type MetadataIconsContainerProps = {
  children: React.ReactElement
  message: string
  annotationMessage?: string
}

const MetadataIconsContainer = ({
  children,
  message,
  annotationMessage
}: MetadataIconsContainerProps) => {
  const theme = useDisplayTheme() as Theme

  return (
    <StyledMetadataIcon mode={theme}>
      <StyledIconContainer> {children}</StyledIconContainer>
      <StyledMessageContainer>{message}</StyledMessageContainer>
      {annotationMessage && (
        <StyledAnnotationNote mode={theme}>{annotationMessage}</StyledAnnotationNote>
      )}
    </StyledMetadataIcon>
  )
}

export default MetadataIconsContainer
